import { useReducer } from 'react';
import { produce } from 'immer';
import { uniqueId, without } from 'lodash';

import createReducer from 'src/utils/createReducer';

const OPEN_POPUP = 'OPEN_POPUP';
const CLOSE_POPUP = 'CLOSE_POPUP';
const CLOSE_ALL_POPUPS = 'CLOSE_ALL_POPUPS';

const INITIAL_STATE = {
  activePopupsMap: new Map(),
  stack: [],
};

export const openPopup = (popupName, popupProps) => ({
  type: OPEN_POPUP,
  popupName,
  popupProps,
});

export const closePopup = (popupName) => ({ type: CLOSE_POPUP, popupName });

export const closeAllPopups = () => ({ type: CLOSE_ALL_POPUPS });

const popupReducer = createReducer(
  {
    [OPEN_POPUP]: (state, { popupName, popupProps }) =>
      produce(state, (draft) => {
        draft.activePopupsMap.set(popupName, {
          open: true,
          key: uniqueId(popupName),
          popupProps,
        });
        draft.stack.push(popupName);
      }),

    [CLOSE_POPUP]: (state, { popupName }) =>
      produce(state, (draft) => {
        if (draft.activePopupsMap.has(popupName)) {
          draft.activePopupsMap.get(popupName).open = false;
        }
        draft.stack = without(draft.stack, popupName);
      }),

    [CLOSE_ALL_POPUPS]: (state) =>
      produce(state, (draft) => {
        draft.activePopupsMap = new Map();
        draft.stack = [];
      }),
  },
  INITIAL_STATE
);

export const usePopupReducer = () => useReducer(popupReducer, INITIAL_STATE);
